import React, { Fragment, useEffect, useRef, useState } from "react";
import NotifSound from "assets/sounds/chat-notification.mp3";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import { motorPaths } from "common/data/routePaths";

const NotificationSound = ({}) => {
  const location = useLocation();
  const pathname = location.pathname;
  const audioRef = useRef(null);
  const [prevLength, setPrevLength] = useState(0);

  const { notifications } = useSelector((state) => ({
    notifications: state.Notifications.notifications,
  }));

  useEffect(() => {
    setPrevLength(notifications.length);
  }, [notifications]);

  useEffect(() => {
    // play sound notification
    if (
      notifications.length > prevLength &&
      pathname === motorPaths.fnol &&
      audioRef.current
    ) {
      audioRef.current.currentTime = 0; // Rewind to start
      audioRef.current.volume = 0.3;
      audioRef.current
        .play()
        .catch((e) => console.log("Audio play failed:", e));
    }
  }, [audioRef, prevLength, notifications, pathname]);

  return (
    <Fragment>
      {/* Hidden audio element */}
      <audio ref={audioRef} src={NotifSound} className="d-none" />
    </Fragment>
  );
};

export default NotificationSound;
